









import { Component, Mixins, Watch } from "vue-property-decorator";
import {NotificationsByContract} from "@/models/contract";
import NotificationTable from "@/components/for-documents-view/NotificationTable.vue";
import AppApiMixin from "@/components/mixins/AppApi.vue";
import {NotificationsAsReqBody} from "@/models/app-api";
import moment from "moment";

@Component({
  components: {
    NotificationTable
  },
})
class Notifications extends Mixins(AppApiMixin) {
  docsProps: NotificationsAsReqBody = {
    contractId: -1,
    from: "",
    to: "",
  };

  notificationsList: NotificationsByContract[] = [];

  @Watch("docsProps")
  public docsPropsChanged() {
    const {contractId, from, to} = this.docsProps;
    this.getNotificationsByContract(
        {contractId, from: moment(from).startOf('month').format('YYYY-MM-DDT00:00:00'), to: moment(to).endOf('month').format('YYYY-MM-DDT00:00:00')},
        (notificationsList: NotificationsByContract[]) => {
          this.notificationsList = notificationsList.sort((a: any, b: any) => {
            let dateA: any = moment(a['датавремя']).valueOf();
            let dateB: any = moment(b['датавремя']).valueOf();
            return dateB - dateA;
          });
        }
    );
  }
}

export default Notifications;
